var map = {
	"./order-detail-check-1.svg": "xYPz",
	"./order-detail-express.svg": "h7PJ",
	"./order-detail-finish.svg": "6Q8s",
	"./order-detail-list-0.svg": "7iYF",
	"./order-detail-list-1.svg": "S+wI",
	"./order-detail-loading.svg": "g3Vg",
	"./order-detail-pintuan-0.svg": "N2jj",
	"./order-detail-pintuan-1.svg": "Vd6E",
	"./order-detail-store.svg": "hErR",
	"./order-detail-submit.svg": "9vL1",
	"./order-detail-time.svg": "xu+h"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6fyO";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/order-detail nonrecursive \.svg$
// module id = 6fyO
// module chunks = 65